import React from 'react';
import './checkout.scss';
import {
  getPaymentDetails,
  getPGCustomerId,
  validateUPI,
  getPaymentSummary,
} from 'hb-redux-store/feature/checkout/checkout.action';
import { connect } from 'react-redux';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';
import Cards from '../../components/mweb/Payments/Cards';
import Upis from '../../components/mweb/Payments/Upis';
import Loader from '../../components/mweb/Skeletons/Loader/Loader';
import Wallets from '../../components/mweb/Payments/Wallets';
import NetBanks from '../../components/mweb/Payments/NetBanks';
import COD from './COD';
import { postPlaceOrder } from 'hb-redux-store/feature/checkout/checkout.action';
import { getCheckoutRoute } from './checkout.routes';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { setCartQtyCount } from 'hb-redux-store/feature/cart/cart.action';
import history from 'hb-redux-store/history';
import { CHECKOUT_FAILURE_REDIRECT } from 'hb-redux-store/util/constantServices';
import {
  setPaymentFailModal,
  setPaymentSummaryModal,
  showOrderFailedModal,
} from 'hb-redux-store/feature/modal/modal.action';
import RazorpayService from 'hb-redux-store/util/RazorpayService';
import Button from '../../components/common/Button/Button';
import Modal from '../../components/mweb/Modal/Modal';
import {
  convertArrayToObject,
  queryStringToJSON,
} from '../../hb-redux-store/util/miscellaneousServices';
import PreferredPayment from './PreferredPayment';
import { payAndPlaceOrder } from 'hb-redux-store/feature/wallet/wallet.action';
import PaymentHeader from './PaymentHeader';
import AnalyticsService from 'AnalyticsService';
import { MEMBERSHIP_PAYMENT_ERROR_MESSAGE } from 'hb-redux-store/constants/halalboxPrime';
import { HB_PRIME_ROUTE } from 'components/web-feature/Home/constant';

const { clevertap } = AnalyticsService;

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMode: 'hbw',
      razorPayInstance: null,
      paymentInProgress: false,
      showPopupBlockedModal: false,
      razorpayDetails: null,
    };
  }

  paymentInProgress = false;
  PAYMENT_MODES = [
    // { key: 'hbMoney', title: 'Preferred Payment', component: PreferredPayment },
    { key: 'savedCards', title: 'Credit/Debit Cards', component: Cards },
    { key: 'savedUPIs', title: 'UPI', component: Upis },
    { key: 'wallets', title: 'Wallets', component: Wallets },
    { key: 'netBankings', title: 'Net banking', component: NetBanks },
    { key: 'pod', title: 'Pay On Delivery', component: COD },
  ];
  getHbMoneyDetails = () => {
    const payload = {
      mode: 'hbw',
      hbWalletAmount: this.props.paymentMethods.hbWalletAmount,
      totalPayableAmount: this.props.paymentMethods.totalPayableAmount,
      differenceAmount: 0,
      skipShipmentSlot: true,
      successCb: this.successCb,
      failCb: this.failCb,
      isRecharge: false,
    };
    if (payload.hbWalletAmount < payload.totalPayableAmount) {
      payload.differenceAmount =
        payload.totalPayableAmount - payload.hbWalletAmount;
    }
    return payload;
  };
  orderWithHBW = payload => {
    // hbWalletAmount: 400
    // totalPayableAmount: 800
    // const payload = {
    //   mode: 'hbw',
    //   hbWalletAmount: this.props.paymentMethods.hbWalletAmount,
    //   totalPayableAmount: this.props.paymentMethods.totalPayableAmount,
    //   differenceAmount: 0,
    //   skipShipmentSlot: true,
    // };
    // if (payload.hbWalletAmount < payload.totalPayableAmount) {
    //   payload.differenceAmount =
    //     payload.totalPayableAmount - payload.hbWalletAmount;
    // }
    const { productsData, summary, launchInfo } = this.props;
    const { adcCode, customerType } = launchInfo || {};
    const { items = [], selectedShipment = [] } = productsData || {};
    const { orderTotalAmount } = summary?.billingDetails || {};

    if (this.paymentInProgress || this.state.paymentInProgress) return;
    const key = 'Payment Confirmation';
    const clevertapPayload = {
      ...convertArrayToObject(items || []),
      ...convertArrayToObject(selectedShipment || [], 'Delivery_Slots'),
      totalAmount: orderTotalAmount,
      serviceAbleArea: this.props.launchInfo?.adcCode,
      customerType: this.props.launchInfo?.customerType,
      usedHalalBoxMoney: true,
    };
    clevertap.sendCleverTapEvent(key, clevertapPayload);
    this.setState({ paymentInProgress: true }, () => {
      this.paymentInProgress = true;
      this.props.payAndPlaceOrder(payload);
    });
  };

  static getDerivedStateFromProps(prevProps, prevState) {
    const { productsData, summary, launchInfo } = prevProps;
    const { adcCode, customerType } = launchInfo || {};
    const { items = [], selectedShipment = [] } = productsData || {};
    const { orderTotalAmount } = summary?.billingDetails || {};

    if (
      (customerType,
      orderTotalAmount,
      items?.length > 0,
      selectedShipment?.length > 0)
    ) {
      const key = 'Add Payment Info';
      const payload = {
        ...convertArrayToObject(items || []),
        ...convertArrayToObject(selectedShipment || [], 'Delivery_Slots'),
        totalAmount: orderTotalAmount,
        serviceAbleArea: adcCode,
        customerType: customerType,
      };
      clevertap.sendCleverTapEvent(key, payload);
    }
    return null;
  }

  componentDidMount() {
    this.props.getPaymentDetails({ halalboxMoney: false });
    const qs = this.props.location.search;
    const { result, reason } = queryStringToJSON(qs);
    if (result === 'failed' && reason) {
      this.props.setPaymentFailModal({ reason, visible: true });
    }
    RazorpayService.initRazorpay();
  }
  showPgInfoPopup = razorpayDetails => {
    this.setState({ razorpayDetails, showPopupBlockedModal: true });
  };
  openRazorpay = () => {
    const { razorPayErrorCb } = this.state.razorpayDetails;
    RazorpayService.makePayment({
      ...this.state.razorpayDetails,
      razorPayErrorCb: () => {
        this.setState(
          {
            razorpayDetails: null,
            showPopupBlockedModal: false,
          },
          () => {
            razorPayErrorCb();
          }
        );
      },
    });
  };
  failCb = error => {
    this.setState({ paymentInProgress: false }, () => {
      this.paymentInProgress = false;
      if (error?.step) {
        const redirect = error.error?.data?.redirect || error.redirect || null;
        if (redirect?.toLowerCase() === CHECKOUT_FAILURE_REDIRECT.CART) {
          this.props.setAppNotification(
            'Your cart has changed. You will be shortly redirected to cart'
          );
          return setTimeout(() => history.push('/cart'), 2000);
        } else if (
          redirect?.toLowerCase() === CHECKOUT_FAILURE_REDIRECT.SHIPMENT
        ) {
          this.props.setAppNotification(
            'Error with delivery slots. You will be shortly redirected to choose slot.'
          );
          return setTimeout(
            () => history.push(getCheckoutRoute('shipment')),
            2000
          );
        } else if (
          redirect?.toLowerCase() === CHECKOUT_FAILURE_REDIRECT.ORDER_FAILURE
        ) {
          this.props.showOrderFailedModal(true);
          history.push('/cart');
        } else if (
          redirect?.toLowerCase() === CHECKOUT_FAILURE_REDIRECT.PG_NOT_LOADED
        ) {
          this.props.setAppNotification(
            'Error loading Payment Gateway. Refresh and try again.'
          );
        } else if (redirect === CHECKOUT_FAILURE_REDIRECT.SHOW_PG_INFO_POPUP) {
          this.showPgInfoPopup(error.pgDetails);
        } else if (
          redirect === CHECKOUT_FAILURE_REDIRECT.MEMBERSHIP_LANDING_SCREEN
        ) {
          this.props.setAppNotification(MEMBERSHIP_PAYMENT_ERROR_MESSAGE);
          history.push(HB_PRIME_ROUTE);
        }
      } else {
        this.props.setAppNotification(
          error?.errorMessage || 'Fail to process payment. Please try again.'
        );
      }
    });
  };
  successCb = ({ orderNo }) => {
    const { productsData, summary, launchInfo } = this.props;
    const { adcCode } = launchInfo || {};
    const { items = [], selectedShipment = [] } = productsData || {};
    const { orderTotalAmount } = summary?.billingDetails || {};
    if ((orderTotalAmount, items?.length > 0, selectedShipment?.length > 0)) {
      const key = 'Payment Confirmation';
      const payload = {
        ...convertArrayToObject(items || []),
        ...convertArrayToObject(selectedShipment || [], 'Delivery_Slots'),
        totalAmount: orderTotalAmount,
        serviceAbleArea: adcCode,
        usedHalalBoxMoney: false,
      };
      clevertap.sendCleverTapEvent(key, payload);
    }

    this.props.setCartQtyCount(0);
    this.paymentInProgress = false;
    history.push(
      getCheckoutRoute('orderConfirmation').replace(':orderNo', orderNo)
    );
  };
  onPlaceOrder = details => {
    if (this.paymentInProgress || this.state.paymentInProgress) return;
    RazorpayService.initRazorpay();
    this.paymentInProgress = true;
    this.setState({ paymentInProgress: true }, () => {
      const payload = {
        ...details,
        amount: this.props.summary?.billingDetails?.payableAmount,
        isPartialPayment: !!this.props.summary?.isPartialPayment,
        pgCid: this.props.pgCid,
        pgId: this.props.paymentMethods.pgId,
        successCb: this.successCb,
        failCb: this.failCb,
      };
      this.props.postPlaceOrder(payload);
    });
  };

  onPaymentModeChange = newMode => {
    if (
      this.props.summary?.isPartialPayment &&
      this.props.summary?.billingDetails.diffPartialPaymentAmount === 0 &&
      newMode !== 'hbw'
    ) {
      this.props.getPaymentSummary({
        isPartialPayment: false,
        cb: () => {
          this.setState({ selectedMode: newMode });
        },
      });
    } else {
      this.setState({ selectedMode: newMode });
    }
  };
  render() {
    const { summary, paymentMethods } = this.props;
    return (
      <div className="payments">
        {(!summary || !paymentMethods) && <Loader />}
        {summary && paymentMethods && (
          <React.Fragment>
            <PaymentHeader
              summary={summary}
              onCheckChange={data => {
                let cb = null;
                if (
                  !summary?.isPartialPayment &&
                  summary?.billingDetails?.hbWalletAmount >=
                    summary?.billingDetails?.payableAmount
                ) {
                  cb = () => this.setState({ selectedMode: 'hbw' });
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
                this.props.getPaymentSummary({ ...data, cb });
              }}
              onShowSummary={() =>
                this.props.setPaymentSummaryModal({
                  visible: true,
                  summary,
                })
              }
            />
            <div className="payments--payment-modes">
              {paymentMethods.isHBWMode && (
                <PreferredPayment
                  title="Preferred Payment"
                  selectedMode={this.state.selectedMode}
                  onPaymentModeChange={this.onPaymentModeChange}
                  onPlaceOrder={this.orderWithHBW}
                  details={this.getHbMoneyDetails()}
                  code={'hbw'}
                />
              )}{' '}
              {this.PAYMENT_MODES.map(mode => {
                // if (!paymentMethods[mode.key]) return null;
                const podProps = {};
                if (mode.key === 'pod') {
                  podProps.isCodEnable = paymentMethods.isCOD;
                  podProps.codMessage = paymentMethods.isCODMessage;
                  podProps.isPodEnable = paymentMethods.isPOD;
                  podProps.podMessage = paymentMethods.isPODMessage;
                }
                return (
                  <mode.component
                    title={mode.title}
                    details={paymentMethods[mode.key]}
                    selectedMode={this.state.selectedMode}
                    onPaymentModeChange={this.onPaymentModeChange}
                    onPlaceOrder={this.onPlaceOrder}
                    validateUPI={this.props.validateUPI}
                    key={mode.key}
                    code={mode.key}
                    pgId={paymentMethods.pgId}
                    {...podProps}
                  />
                );
              })}
            </div>
          </React.Fragment>
        )}
        <Modal
          visible={this.state.showPopupBlockedModal}
          onCancel={() => this.setState({ showPopupBlockedModal: false })}
          closable={false}
          maskClosable={false}
          wrapClassName="pg-modal-failed"
        >
          <div className="pg-modal-failed--content">
            Proceed to payment
            <br />
          </div>
          <div className="pg-modal-failed--cta">
            <Button
              className="button button-primary full-width"
              onClick={this.openRazorpay}
            >
              Pay Now
            </Button>
          </div>
        </Modal>
        {(this.state.paymentInProgress || this.props.checkoutLoading) && (
          <div className="payments--oip">
            <Loader />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({
  checkoutReducer,
  modalReducer,
  initialReducer,
}) => ({
  summary: checkoutReducer.summary,
  paymentMethods: checkoutReducer.paymentMethods,
  checkoutLoading: checkoutReducer.checkoutLoading,
  pgCid: checkoutReducer.pgCid,
  productsData: checkoutReducer.productsData,
  orderFailedModal: modalReducer.orderFailedModal,
  launchInfo: initialReducer.launchInfo,
});

const mapDispatchToProps = {
  getPaymentDetails,
  getPGCustomerId,
  postPlaceOrder,
  setAppNotification,
  validateUPI,
  setCartQtyCount,
  showOrderFailedModal,
  payAndPlaceOrder,
  setPaymentFailModal,
  getPaymentSummary,
  setPaymentSummaryModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
